import { Component, OnDestroy } from '@angular/core';
import { ConvenientCareSettingsService } from '../../../services/convenient-care/convenient-care.settings.service';
import { PromotionalsSetting } from '@interfaces/promotionals-setting.model';
import { trigger, transition, useAnimation } from '@angular/animations';
import { fadeIn } from 'ng-animate';
import { Subscription } from 'rxjs';
import { SubscriptionManager } from '@zelis/platform-ui-components';
import { TrackByUtilities } from '../../../utilities/trackByFn.utilities';
import { CcssService } from '../../../services/ccss/ccss.service';
import { filter } from 'rxjs/operators';

const widthValue = 384;

@Component({
  selector: 'app-convenient-care',
  templateUrl: './convenient-care.component.html',
  styleUrls: ['./convenient-care.component.scss'],
  providers: [ConvenientCareSettingsService],
  animations: [
    trigger('fadeIn', [
      transition(
        '* => *',
        useAnimation(fadeIn, {
          params: { timing: 1.1 },
        })
      ),
    ]),
  ],
})
export class ConvenientCareComponent implements OnDestroy {
  public cardWidth: string = widthValue + 'px';
  public settings: PromotionalsSetting[] = [];
  public benefitsClass: string;
  public trackByFnIndex: any = TrackByUtilities.trackByFnIndex;
  private subscriptions = new SubscriptionManager();

  constructor(
    public ccss: CcssService,
    private convenientCareSettings: ConvenientCareSettingsService
  ) {
    // account-specific settings for order and redirect_urls
    this.subscriptions.add(this.subscribeToSettings());
  }

  ngOnDestroy() {
    this.subscriptions.destroy();
  }

  private subscribeToSettings(): Subscription {
    return this.convenientCareSettings.settings
      .pipe(filter((settings) => !!settings))
      .subscribe((settings) => {
        this.settings = settings.cards ? settings.cards.slice(0, 3) : [];
        this.benefitsClass = this.ccss.getClass('benefits');
      });
  }
}
